export default "__VITE_ASSET__US9VFGRo__"